import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { GenerateKpiDropDownItems, Kpi } from "@app/shared/classes/kpi";
import { SubRegion } from "@app/shared/classes/sub-region";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { CommonFieldLabel, CommonFieldName } from "@app/shared/constants";
import { BooleanYesNoEmptyTranslate } from "@app/shared/pipes/boolean-yes-no-empty-translate";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { DynamicTranslate } from "@app/shared/pipes/dynamic-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { LocaleTime } from "@app/shared/pipes/locale-time";

export enum DrivingBehaviorFieldName {
  country = "country",
  driverName = "driverName",
  date = "date",
  time = "time",
  kpiTime = "kpiTime",
  vehicle = "vehicle",
  speed = "speed",
  duration = "duration",
  classification = "classification",
  kpiLocation = "kpiLocation",
  videoUrl = "videoUrl",
  gpsmonitor = "gpsMonitor",
  compliance = "compliance",
  description = "description",
  kpiName = "kpiName",
  kpi_Translation_Id = "kpi_Translation_Id",
  created_By = "created_By",
  created_On = "created_On",
  lastModified_By = "lastModified_By",
  lastModified_On = "lastModified_On",

  apexId = "apexId",
  fullName = "fullName",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
};

enum FieldLabel {
  COUNTRY = "ml_143912",
  DRIVER_NAME = "ml_143908",
  KPI_DATE = "ml_151034",
  KPI_TIME = "ml_144009",
  VEHICLE = "ml_143960",
  SPEED = "ml_143961",
  DURATION = "ml_143962",
  CLASSIFICATION = "ml_144126",
  LOCATION = "ml_144127",
  VIDEO_URL = "ml_143963",
  GPS_MONITOR = "ml_151076",
  COMPLIANCE = "ml_143915",
  DESCRIPTION = "ml_143964",
  KPI_NAME = "ml_143913",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",

  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",

  DRIVER_APEX_ID = "ml_143930",
}

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.DRIVER_NAME,
    name: DrivingBehaviorFieldName.driverName,
    sort: true,
    sortFieldName: DrivingBehaviorFieldName.fullName
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: DrivingBehaviorFieldName.terminalId,
    sort: true,
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: DrivingBehaviorFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: DrivingBehaviorFieldName.subRegionName,
    sort: true
  },
  {
    text: FieldLabel.COUNTRY,
    name: DrivingBehaviorFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.KPI_DATE,
    name: DrivingBehaviorFieldName.date,
    sort: true,
    pipe: LocaleDate,
    sortFieldName: DrivingBehaviorFieldName.kpiTime
  },
  {
    text: FieldLabel.KPI_TIME,
    name: DrivingBehaviorFieldName.time,
    pipe: LocaleTime,
    sortFieldName: DrivingBehaviorFieldName.kpiTime
  },
  {
    text: FieldLabel.VEHICLE,
    name: DrivingBehaviorFieldName.vehicle,
    sort: true
  },
  {
    text: FieldLabel.SPEED,
    name: DrivingBehaviorFieldName.speed,
    sort: true
  },
  {
    text: FieldLabel.DURATION,
    name: DrivingBehaviorFieldName.duration,
    sort: true
  },
  {
    text: FieldLabel.CLASSIFICATION,
    name: DrivingBehaviorFieldName.classification,
    sort: true
  },
  {
    text: FieldLabel.LOCATION,
    name: DrivingBehaviorFieldName.kpiLocation,
    sort: true
  },
  {
    text: FieldLabel.VIDEO_URL,
    name: DrivingBehaviorFieldName.videoUrl
  },
  {
    text: FieldLabel.GPS_MONITOR,
    name: DrivingBehaviorFieldName.gpsmonitor,
    sort: true
  },
  {
    text: FieldLabel.COMPLIANCE,
    name: DrivingBehaviorFieldName.compliance,
    sort: true,
    pipe: BooleanYesNoEmptyTranslate
  },
  {
    text: FieldLabel.DESCRIPTION,
    name: DrivingBehaviorFieldName.description,
    sort: true
  },
  {
    text: FieldLabel.KPI_NAME,
    name: DrivingBehaviorFieldName.kpi_Translation_Id,
    sort: true,
    pipe: DynamicTranslate
  },
  {
    text: FieldLabel.CREATED_BY,
    name: DrivingBehaviorFieldName.created_By,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: DrivingBehaviorFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: DrivingBehaviorFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: DrivingBehaviorFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
]

const DrivingBehaviorSearchByList: SearchByItem[] = [
  { searchBy: DrivingBehaviorFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  { searchBy: DrivingBehaviorFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: DrivingBehaviorFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: DrivingBehaviorFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: DrivingBehaviorFieldName.kpiName, searchByLabel: FieldLabel.KPI_NAME, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: DrivingBehaviorFieldName.kpiTime, searchByLabel: FieldLabel.KPI_DATE, searchByType: smartSearchType.dateRangeSelct },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const GetDrivingBehaviorSearchByList = ([terminals, subRegions, kpis, userCountry]: [DropDownItem[], SubRegion[], Kpi[], string]) => {
  var result = DrivingBehaviorSearchByList.slice();
  result[2].searchDropDownValue = terminals;
  result[3].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  result[4].searchDropDownValue = GenerateKpiDropDownItems(
    kpis.filter(kpi => kpi && kpi.kpiConfigurations && kpi.kpiConfigurations.filter(config => config && config.country === userCountry).length > 0));
  return result;
}
